import { CONFIRMED_GET_TOKEN_MULTI_LIST, SET_PAUSED_DOCTOR_ID } from "../actions/TokenMultiSytemType"

const initialState = {
  tokenMultiList: [],
  pausedDoctorId: null, // New state to track which doctor is paused
}

export default function TokenMultiSystemReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_TOKEN_MULTI_LIST:
      return {
        ...state,
        tokenMultiList: action.payload,
      }
    case SET_PAUSED_DOCTOR_ID: // Handle the new action
      return {
        ...state,
        pausedDoctorId: action.payload,
      }
    default:
      return state
  }
}
